import React from 'react';
import withLayout from '../../../hocs/Layout';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Typography, Divider } from '@mui/material';
import PendingOrders from './PendingOrders';
import ApprovedOrders from './ApprovedOrders';
import RejectedOrders from './Rejected';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CancelIcon from '@mui/icons-material/Cancel';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AutoApprovedCompleted from './AutoReturns/AutoApproveCompleted';
import AutoApproveFailed from './AutoReturns/AutoApproveFailed';
import PageTitle from '../../../common/PageTitle';
import { pageContainerSx, tabContainerSx, tabPanelSx } from '../../../styles/patterns';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY, BORDER, SUBTLE, WHITE, PRIMARY_BLUE, SUCCESS, ERROR, withOpacity } from '../../../styles/foundation/colors';


const ReturnOrders = () => {
    const [value, setValue] = React.useState("1");

    // Same status-tab design as the Forward D2C Shipments page (list2/index.js):
    // a bordered white card of icon + label cells with an active colour underline.
    const tabs = [
        { label: 'Pending', icon: <PauseCircleFilledIcon />, color: PRIMARY_BLUE, value: '1' },
        { label: 'Approved', icon: <DoneAllIcon />, color: SUCCESS, value: '2' },
        { label: 'Rejected', icon: <CancelIcon />, color: ERROR, value: '3' },
        { label: 'Auto Approve Completed', icon: <TaskAltIcon />, color: SUCCESS, value: '4' },
        { label: 'Auto Approve Failed', icon: <CancelIcon />, color: ERROR, value: '5' },
    ];

    return (
        <Box sx={pageContainerSx}>
            <PageTitle subTitle="Review and action pending, approved and rejected returns">Return Orders</PageTitle>

            <TabContext value={value}>
                <Box sx={tabContainerSx}>
                    {/* Status tabs — mirrors Forward D2C Shipments */}
                    <Box sx={{ bgcolor: WHITE, border: `1px solid ${BORDER}`, borderRadius: '12px', mb: 2, overflow: 'hidden' }}>
                        <Box sx={{ display: 'flex', overflowX: 'auto' }}>
                            {tabs.map((t, i) => {
                                const isActive = value === t.value;
                                return (
                                    <React.Fragment key={t.value}>
                                        {i > 0 && <Divider orientation="vertical" flexItem sx={{ borderColor: BORDER }} />}
                                        <Box
                                            onClick={() => setValue(t.value)}
                                            sx={{
                                                flex: '1 1 auto', flexShrink: { xs: 0, md: 1 }, minWidth: 140, py: 1.25, px: 2, cursor: 'pointer',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                                                borderBottom: isActive ? `3px solid ${t.color}` : '3px solid transparent',
                                                bgcolor: isActive ? withOpacity(t.color, 0.06) : 'transparent',
                                                transition: 'all 0.15s',
                                                '&:hover': { bgcolor: withOpacity(t.color, 0.04) },
                                            }}
                                        >
                                            <Box sx={{
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                width: 30, height: 30, borderRadius: '8px', flexShrink: 0,
                                                bgcolor: isActive ? withOpacity(t.color, 0.12) : withOpacity(t.color, 0.07),
                                                color: isActive ? t.color : SUBTLE,
                                                '& .MuiSvgIcon-root': { fontSize: 17 },
                                            }}>
                                                {t.icon}
                                            </Box>
                                            <Typography sx={{
                                                fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold,
                                                color: isActive ? NAVY : SUBTLE, lineHeight: 1.2, whiteSpace: 'nowrap',
                                            }}>
                                                {t.label}
                                            </Typography>
                                        </Box>
                                    </React.Fragment>
                                );
                            })}
                        </Box>
                    </Box>

                    <TabPanel value="1" sx={tabPanelSx}>
                        <PendingOrders />
                    </TabPanel>
                    <TabPanel value="2" sx={tabPanelSx}>
                        <ApprovedOrders />
                    </TabPanel>
                    <TabPanel value="3" sx={tabPanelSx}>
                        <RejectedOrders />
                    </TabPanel>
                    <TabPanel value="4" sx={tabPanelSx}>
                        <AutoApprovedCompleted />
                    </TabPanel>
                    <TabPanel value="5" sx={tabPanelSx}>
                        <AutoApproveFailed />
                    </TabPanel>
                </Box>
            </TabContext>
        </Box>
    );
}

export default withLayout(ReturnOrders);
